export function formatPid(value: number | string | null | undefined): string {
  if (value?.toString().length !== 11) return "****** *****";

  const numericValue = typeof value === "number" ? value.toString() : value;
  const formatted = numericValue.replace(/(\d{6})(\d{5})/, "$1 $2");
  const [integer, hidden] = formatted.split(" ");
  return `${integer} ${hidden ? "******" : ""}`.trim();
}
